<template>
	<div>
		<transition>
      <div class="w-100 fixed-top" v-show="action_success.show">
        <b-row class="justify-content-center" no-gutters>
          <b-col cols="12" sm="8" md="6" lg="4" xl="4">
            <div class="p-3 border mb-3 radius-0 text-center" style="background-color: rgb(243, 255, 249); border-color: rgb(184, 254, 205) !important;">
              <p class="mb-0 body-3-1">{{action_success.message}}</p>
            </div>
          </b-col>
        </b-row>
      </div>
    </transition>
		<div class="w-100 text-center py-3 border-bottom">
			<p class="body-2 mb-1">{{$t('payment-result.payment-time')}}</p>
			<p class="heading-4-1 mb-0" v-if="timeout">00:00:00</p>
			<p v-else class="heading-4-1 mb-0">
				<template v-if="countdown.hours() < 10">
					0{{countdown.hours()}}:
				</template>
				<template v-else>
					{{countdown.hours()}}:
				</template>
				<template v-if="countdown.minutes() < 10">
					0{{countdown.minutes()}}:
				</template>
				<template v-else>
					{{countdown.minutes()}}:
				</template>
				<template v-if="countdown.seconds() < 10">
					0{{countdown.seconds()}}
				</template>
				<template v-else>
					{{countdown.seconds()}}
				</template>
			</p>
			<!-- <p class="body-3-3-1 mb-0">Sebelum Jumat, 24 Juli 2020, 17:25</p> -->
		</div>
		<div class="w-100 py-3 text-center border-bottom">
			<p class="body-3 mb-1">{{$t('payment-result.payment-paid')}}</p>
			<p class="body-2-4 text-orange mb-1 text-22">{{formatCurrency(total_payment)}}</p>
			<PaymentChargeInfo v-if="chargeInfo" :charge-info="chargeInfo" class="mb-1" />
			<p class="body-3 mb-0 text-green cursor-pointer" @click="copyField(total_payment, $t('payment-result.total-bill-copy'))">{{$t('payment-result.copy-amount')}}</p>
		</div>
		<div class="w-100 py-3 text-center border-bottom" v-if="tx.payment_details.bank_name == 'WISE'">
			<div v-if="reload">
				<loader></loader>
			</div>
			<template v-else>
				<template v-if="link_to_pay == null">
					<p class="body-2-2 mb-2">The link to pay has not been created.<br />Please wait a moment</p>
					<p class="body-2-2 mb-0 text-green cursor-pointer" @click="geTxDetail">Refresh</p>
				</template>
				<button v-else type="button" class="button-primary border text-white px-4" @click="clickToPay">Click here to pay</button>
			</template>
		</div>
		<div class="w-100 py-3 text-center">
			<div class="container p-3 text-left bg-light rounded-6 box-shadow-bold border mb-3">
      	<template v-if="tx.payment_details.bank_name == 'DIRECT_PAYMENT'">
	        <div class="row slim-grid-row position-relative text-center" v-if="tx.payment_details.payment_method == 'BANK_TRANSFER'">
	        	<div class="col-12 pb-3 mb-3 border-bottom">
	        		<img :src="tx.payment_details.image_url" height="50" class="mx-auto mb-2">
	        		<p class="body-2-4 text-orange mb-0">{{tx.payment_details.name}}</p>
	        		<p class="body-2-2 mb-0">{{tx.payment_details.ch_ref1}} (Account Holder)</p>
	        		<p class="body-3-1 mb-0" v-if="!(tx.payment_details.ch_ref3 == null || tx.payment_details.ch_ref3 == '')">Swift : {{tx.payment_details.ch_ref3}}</p>
	        		<p class="body-3-3-1 mb-0" v-if="!(tx.payment_details.payment_channel_description == null || tx.payment_details.payment_channel_description == '')" v-html="tx.payment_details.payment_channel_description"></p>
	        	</div>
	        	<div class="col-12">
	        		<p class="heading-6-1 mb-1">{{tx.payment_details.ch_ref2}}</p>
	        		<p class="body-3-1 mb-0 text-orange border-orange d-table mx-auto px-2 rounded cursor-pointer" @click="copyField(tx.payment_details.ch_ref2,'Account number copied!')">Copy</p>
	        	</div>
	        </div>
	        <template v-else>
	        	<p class="heading-6-1 mb-2 pb-2 border-bottom w-100 text-center">QRIS</p>
	        	<div class="row">
	        		<div class="col-12 text-center col-sm-6 offset-sm-3">
		        		<img :src="tx.payment_details.qr_image" class="w-100 mb-3 mx-auto">
	        		</div>
	        	</div>
		        <p class="body-3-1 mb-2 text-orange border-orange d-table mx-auto px-2 rounded cursor-pointer" @click="downloadQris(tx.payment_details.qr_image)">Download QRIS</p>
		        <p class="body-3-3-1 mb-0 text-center" v-if="!(tx.payment_details.payment_channel_description == null || tx.payment_details.payment_channel_description == '')" v-html="tx.payment_details.payment_channel_description"></p>
		      </template>
	      </template>
	      <template v-else>
	        <p class="body-2-2 mb-2" v-html="tx.payment_details.how_to_pay"></p>
	        <p class="body-3-3-1 mb-0" v-if="!(tx.payment_details.payment_channel_description == null || tx.payment_details.payment_channel_description == '')" v-html="tx.payment_details.payment_channel_description"></p>
	      </template>
      </div>
      <button v-if="tx.payment_details.bank_name == 'DIRECT_PAYMENT' || (tx.payment_details.bank_name == 'WISE' && link_to_pay != null)" type="button" class="button-secondary border text-white px-4" @click="goToConfirmPayment">{{$t("hotel.waiting.confirm-payment")}}</button>
		</div>
	</div>
</template>
<script>
	import {mapGetters} from 'vuex'
	import {formatCurrency,formatDate,buildTxChargeInfo} from '@/utils/index.js'
	import moment from 'moment';
	import {get} from '@/services/index.js'
	import PaymentChargeInfo from '@/components/v2/payment/PaymentChargeInfo.vue'

	export default{
		components:{
			PaymentChargeInfo
		},
		props: ['tx'],
		data(){
			return{
				countdown: moment(),
	      timeout: false,
				action_success:{
          show: false,
          message: '',
          timer: 0
        },
        link_to_pay: null,
        reload: false
			}
		},
		computed:{
			show_success(){
        return this.action_success.show
      },
      total_payment(){
      	return Number(this.tx.payments.total_deposit)+Number(this.tx.payments.payment_surcharge)
      },
      chargeInfo(){
        return buildTxChargeInfo(this.tx.payments)
      }
		},
		watch:{
			show_success(){
        if (this.action_success.show) {
          let looping = setInterval(() => {
            if (this.action_success.timer > 0) {
              this.action_success.timer--
            }else if(this.action_success.timer == 0){
              this.action_success.show = false
              this.action_success.message = ''
              clearInterval(looping)
            }
          },1000)
        }
      }
		},
		mounted(){
			this.link_to_pay = this.tx.link_to_pay
			this.countAutoCancel()
		},
		methods:{
			...mapGetters(['getMerchant']),
			formatDate(date){
        return formatDate(date);
      },
      formatCurrency(value){
        return formatCurrency(value);
      },
			countAutoCancel(){
				let now = moment()
	      let now_formatted = moment(now).format("YYYY-MM-DD HH:mm:ss")
	      let expired_at = moment(this.tx.created_at).local()
	      let expired_at_formatted = moment(expired_at).add(this.tx.payment_details.payment_validation_time,'h').format("YYYY-MM-DD HH:mm:ss")
	      // console.log("durasi : ",moment.duration(created_at.diff(moment(current_formatted))))
	      this.countdown = moment.duration(moment(expired_at_formatted).diff(moment(now_formatted)))

	      let looping = setInterval(() => {
	          this.countdown = this.countdown.subtract(1, 'seconds')
	        if (this.countdown.hours() <= 0 && this.countdown.minutes() <= 0 && this.countdown.seconds() <= 0) {
	          clearInterval(looping)
	          this.timeout = true
	        }
	      },1000)
			},
      copyField(data,message){
				var value = data
        var input_temp = document.createElement("input");
        input_temp.value = value;
        document.body.appendChild(input_temp);
        input_temp.select();
        document.execCommand("copy");
        document.body.removeChild(input_temp);
        this.action_success.show = true
        this.action_success.message = message
        this.action_success.timer = 2
			},
			downloadQris(url){
				window.open(url,'_blank')
			},
			goToConfirmPayment(){
				this.$router.push({
					path: `/${this.getMerchant().code}/be/confirm-payment/${this.$route.params.tx_order_id}`,
					query: this.$route.query.tx_sk ? { tx_sk: this.$route.query.tx_sk } : {}
				})
			},
			clickToPay(){
				window.open(this.link_to_pay,'_blank')
			},
			geTxDetail(){
				this.reload = true
				let params ={
      		merchant_id : this.getMerchant().id,
				}
				get("CORE_HOTEL","tx-detail/"+this.$route.params.tx_order_id,params).then(response=>{
					let res = response.data
					if(res.success){
						this.link_to_pay = res.data.link_to_pay
					}
					this.reload = false
				})
			},
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/hotel/be/DirectPayment.vue